export const environment = {
  production: true,
  prodStyle: false
};



// WEBPACK FOOTER //
// /opt/app/develop/src/environments/environment.ts